/* eslint-disable import/prefer-default-export */
import {
  SET_IS_TOGGLE_ON,
  ORDER_VEHICLE_TYPE,
  ORDER_PASSENGER_COURT,
  ORDER_TUNNEL,
  ORDER_PICKUP_TIME,
  ORDER_NEED_OVER_6FT,
  ORDER_REMOVE_NET,
  ORDER_NEED_CART,
  ORDER_CART_COUNT,
  ORDER_NEED_CARRY,
  ORDER_NEED_NEW_CAR,
  ORDER_NEED_PET,
  ORDER_NEED_WASTE,
  ORDER_PAY_BY_RECEIVER,
  ORDER_ADD_ADDRESS,
  ORDER_UPDATE_ADDRESS,
  ORDER_ADD_IMAGE,
  ORDER_UPDATE_IMAGE,
  ORDER_REMOVE_IMAGE,
  ORDER_ID_DETAIL,
  SET_DRIVER_BLACKLIST,
  ORDER_PRICE_BREAKDOWN_DETAIL,
  ORDER_REMARK,
  ORDER_COUPON,
  IS_CLICK_CONFIRM_ORDER,
  IS_VALID_ORDER,
  ADD_UPLOADED_ORDER_IMAGE,
  UPDATE_ORDER_DETAIL_INFO,
  ADD_ORDER_DETAIL_INFO,
  INIT_ORDER_DETAIL_INFO,
  IS_SHOW_COUPON,
  IS_UPLOADED_CLIENT_PHOTO,
} from '../constants';

export function setIsToggleOn() {
  return dispatch =>
    dispatch({
      type: SET_IS_TOGGLE_ON,
      payload: {},
    });
}

export function setOrderVehicleType(vehicle) {
  return dispatch =>
    dispatch({
      type: ORDER_VEHICLE_TYPE,
      payload: vehicle,
    });
}

export function addOrderAddress(address) {
  return dispatch =>
    dispatch({
      type: ORDER_ADD_ADDRESS,
      payload: address,
    });
}
export function updateOrderAddress(address, index) {
  return dispatch =>
    dispatch({
      type: ORDER_UPDATE_ADDRESS,
      payload: address,
      index,
    });
}
export function addOrderImage(image) {
  return dispatch =>
    dispatch({
      type: ORDER_ADD_IMAGE,
      payload: image,
    });
}
export function updateOrderImage(image, index) {
  return dispatch =>
    dispatch({
      type: ORDER_UPDATE_IMAGE,
      payload: image,
      index,
    });
}
export function removeOrderImage(index) {
  return dispatch =>
    dispatch({
      type: ORDER_REMOVE_IMAGE,
      index,
    });
}
export function setPassengerCount(count) {
  return dispatch =>
    dispatch({
      type: ORDER_PASSENGER_COURT,
      payload: count,
    });
}
export function setTunnel(input) {
  return dispatch =>
    dispatch({
      type: ORDER_TUNNEL,
      payload: input,
    });
}
// unless
export function setPickupTime(input) {
  return dispatch =>
    dispatch({
      type: ORDER_PICKUP_TIME,
      payload: input,
    });
}
export function setNeedOver6ft(input) {
  return dispatch =>
    dispatch({
      type: ORDER_NEED_OVER_6FT,
      payload: input,
    });
}
export function setRemoveNet(input) {
  return dispatch =>
    dispatch({
      type: ORDER_REMOVE_NET,
      payload: input,
    });
}
export function setCartCount(input) {
  return dispatch =>
    dispatch({
      type: ORDER_CART_COUNT,
      payload: input,
    });
}
export function setNeedCart(input) {
  return dispatch =>
    dispatch({
      type: ORDER_NEED_CART,
      payload: input,
    });
}
export function setNeedCarry(input) {
  return dispatch =>
    dispatch({
      type: ORDER_NEED_CARRY,
      payload: input,
    });
}
export function setNeedNewCar(input) {
  return dispatch =>
    dispatch({
      type: ORDER_NEED_NEW_CAR,
      payload: input,
    });
}
export function setNeedPet(input) {
  return dispatch =>
    dispatch({
      type: ORDER_NEED_PET,
      payload: input,
    });
}
export function setNeedWaste(input) {
  return dispatch =>
    dispatch({
      type: ORDER_NEED_WASTE,
      payload: input,
    });
}
export function setPayByReceiver(input) {
  return dispatch =>
    dispatch({
      type: ORDER_PAY_BY_RECEIVER,
      payload: input,
    });
}
export function setOrderIDDetail(input) {
  return dispatch =>
    dispatch({
      type: ORDER_ID_DETAIL,
      payload: input,
    });
}
export function setDriverBlacklist(input) {
  return dispatch =>
    dispatch({
      type: SET_DRIVER_BLACKLIST,
      payload: input,
    });
}
export function setOrderPriceBreakdownDetail(input) {
  return dispatch =>
    dispatch({
      type: ORDER_PRICE_BREAKDOWN_DETAIL,
      payload: input,
    });
}
export function setOrderRemark(input) {
  return dispatch =>
    dispatch({
      type: ORDER_REMARK,
      payload: input,
    });
}
export function setOrderCoupon(input) {
  return dispatch =>
    dispatch({
      type: ORDER_COUPON,
      payload: input,
    });
}
export function setIsClickConfirmOrder(input) {
  return dispatch =>
    dispatch({
      type: IS_CLICK_CONFIRM_ORDER,
      payload: input,
    });
}
export function setIsValidOrder(input) {
  return dispatch =>
    dispatch({
      type: IS_VALID_ORDER,
      payload: input,
    });
}
export function addUploadedOrderImage(input) {
  return dispatch =>
    dispatch({
      type: ADD_UPLOADED_ORDER_IMAGE,
      payload: input,
    });
}
export function updateOrderDetailInfoAction(service, service2, payload) {
  return dispatch =>
    dispatch({
      type: UPDATE_ORDER_DETAIL_INFO,
      service,
      service2,
      payload,
    });
}
export function addOrderDetailInfoAction(service, payload) {
  return dispatch =>
    dispatch({
      type: ADD_ORDER_DETAIL_INFO,
      service,
      payload,
    });
}
export function initOrderDetailInfoAction(payload) {
  return dispatch =>
    dispatch({
      type: INIT_ORDER_DETAIL_INFO,
      payload,
    });
}
export function setIsShowCoupon(payload) {
  return dispatch =>
    dispatch({
      type: IS_SHOW_COUPON,
      payload,
    });
}
export function setIsUploadedClientPhoto(payload) {
  return dispatch =>
    dispatch({
      type: IS_UPLOADED_CLIENT_PHOTO,
      payload,
    });
}



// WEBPACK FOOTER //
// ./src/actions/order.js